import React, { useCallback, useContext, useRef } from 'react'
import PropTypes from 'prop-types'
import ValidationGroup from 'devextreme-react/validation-group'
import { FormContext } from '../../context/FormContext'
import Field from './Field'

const QuestionField = ({ div, submit, next }) => {
  const validationGroup = useRef(null)
  const formContext = useContext(FormContext)

  const { question, options } = formContext.questionData

  const type = question.tipo_pregunta
  const orden = question.orden

  const validateCallback = useCallback(() => {
    const validationGroupInstance = validationGroup.current.instance
    return validationGroupInstance.validate().isValid
  }, [])

  const submitCallback = useCallback((value) => {
    if (!validateCallback()) return

    return submit(value, orden, formContext, div.current)
  }, [validateCallback, submit, orden, formContext, div])

  const nextCallback = useCallback(() => {
    if (!validateCallback()) return

    return next(formContext, div.current)
  }, [validateCallback, next, formContext, div])

  return (
    <ValidationGroup ref={validationGroup} name={question.id_pregunta}>
      <Field type={type} question={question} options={options} submit={submitCallback} next={nextCallback} />
    </ValidationGroup>
  )
}

QuestionField.propTypes = {
  div: PropTypes.object.isRequired,
  submit: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired
}

export default QuestionField
